import { useState } from "react";

export function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    setValues,
    function(event) {
      if (event.target === undefined)
        return
     
      if (event.target.type === 'checkbox'){ // Checkbox
        setValues({
          ...fields,
          [event.target.id]: event.target.checked
        })
      } else if (event.target.name) { // select
        setValues({
          ...fields,
          [event.target.name]: event.target.value
        })
      } else {
        setValues({
          ...fields,
          [event.target.id]: event.target.value
        })
      }
    }
  ];
}
